import React, { memo } from 'react';
import { createUseStyles } from 'hoi-poi-ui';
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'WidgetLayout');
const WidgetLayout = /*#__PURE__*/memo(_ref => {
  let {
    children,
    header,
    footer,
    id,
    isSelected,
    getRef
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref => getRef === null || getRef === void 0 ? void 0 : getRef(ref),
    id: id,
    className: classnames(classes.root, {
      [classes.selected]: isSelected
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, header && header), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, {
      [classes.withFooter]: !!footer
    })
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, footer));
});
export default WidgetLayout;